import React from 'react';
import { useLocation } from 'react-router-dom';
import MyButton from 'component/MuiReusableComponents/MuiButton/buttonMUI';
import { useDispatch } from 'react-redux';
import { Box, FormControl, InputLabel, Select, MenuItem, FormHelperText } from "@mui/material";
import { startGenerateSlip, startSelfGenerateSlip } from "../../../store1/employees data/employeesData.slice.selector";

const SalarySlipPopup = ({ empId, onClose }) => {
    const [month, setMonth] = React.useState('');
    const [year, setYear] = React.useState('');
    const [errors, setErrors] = React.useState({});
    const dispatch = useDispatch();
    const location = useLocation();
    const path = location.pathname;
    const isSelf = path.includes("my-salary-slip");

    const months = [
        { value: "", label: "None (Optional)" },
        { value: "01", label: "January" },
        { value: "02", label: "February" },
        { value: "03", label: "March" },
        { value: "04", label: "April" },
        { value: "05", label: "May" },
        { value: "06", label: "June" },
        { value: "07", label: "July" },
        { value: "08", label: "August" },
        { value: "09", label: "September" },
        { value: "10", label: "October" },
        { value: "11", label: "November" },
        { value: "12", label: "December" }
    ];

    const years = Array.from({ length: 10 }, (_, i) => new Date().getFullYear() - i);

    const validate = () => {
        let temp = {};

        if (!year) temp.year = "Year is required";

        setErrors(temp);
        return Object.keys(temp).length === 0;
    };

    const handleSubmit = () => {
        if (!validate()) return;

        const payload = {
            empId,
            year,
            month: month || ""
        };

        const payload2 = {
            year,
            month: month || ""
        };

        if (isSelf) {
            dispatch(startSelfGenerateSlip(payload2));
        } else {
            dispatch(startGenerateSlip(payload));
        }

        onClose();
    };

    return (
        <Box sx={{ p: 2, minWidth: 320 }}>
            <FormControl fullWidth size="small" sx={{ mt: 2 }} error={!!errors.year}>
                <InputLabel>Select Year</InputLabel>
                <Select
                    value={year}
                    label="Select Year"
                    onChange={(e) => setYear(e.target.value)}
                >
                    {years.map((year) => (
                        <MenuItem key={year} value={year}>{year}</MenuItem>
                    ))}
                </Select>
                {errors.year && <FormHelperText>{errors.year}</FormHelperText>}
            </FormControl>

            <FormControl fullWidth size="small" sx={{ mt: 2 }}>
                <InputLabel>Select Month (Optional)</InputLabel>
                <Select
                    value={month}
                    label="Select Month (Optional)"
                    onChange={(e) => setMonth(e.target.value)}
                >
                    {months.map((m) => (
                        <MenuItem key={m.value} value={m.value}>
                            {m.label}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>

            <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3, gap: 1 }}>
                <MyButton
                    size="small"
                    variant="contained"
                    color="success"
                    onClick={handleSubmit}
                >
                    Get Slip
                </MyButton>
            </Box>
        </Box>
    );
};

export default SalarySlipPopup;
